import { CLUSTERS_FIELDS } from 'shared/constants/map';
import { Cluster } from 'shared/types/Map';

export const parseClusterCount = (cluster: Cluster): number | undefined => {
  const count = cluster.properties?.[CLUSTERS_FIELDS.count];

  if (!count) {
    return undefined;
  }

  return Number(count.replace('+', ''));
};
